<template>
  <div class="theme-switcher">
    <div class="layout-row justify-between">
      <OrSwitch
        :model-value="isDark"
        :label="$t('HITL.common.labels.dark-mode')"
        @update:modelValue="toggleTheme"
      />
      <span class="typography-caption-regular text-on-disabled dark:text-on-disabled-dark">
        {{ getDarkModeHotkey }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue-demi';
import { OrSwitchV3 as OrSwitch } from '@onereach/ui-components-25';
import { useAppThemeTracking } from '@/composables';

export default defineComponent({
  name: 'ThemeSwitcher',
  components: { OrSwitch },
  setup() {
    const { isDarkMode, toggleTheme } = useAppThemeTracking();

    const isDark = computed(() => isDarkMode.value);
    const getDarkModeHotkey = computed((): string => {
      return navigator.platform === 'MacIntel' ? '⇧⌘D' : 'Ctrl + Shift + D';
    });

    return {
      isDark,
      toggleTheme,
      getDarkModeHotkey,
    };
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

.theme-switcher {
  padding: 0 var(--s-5);
  height: 2.125rem;
  display: flex;
  align-items: center;

  .layout-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
  }
}
</style>
